import { Component, ojs, app } from "modular-openscriptjs";
import { either, oneOf } from "../../helpers";

const h = app("h");

export default class Card extends Component {
	render(obj, ...args) {
		let object = {
			title: oneOf(obj.title),
			subtitle: oneOf(obj.subtitle),
			body: oneOf(obj.body),
			links: oneOf(obj.links, []),
			list: oneOf(obj.list, []),
			image: oneOf(obj.image, null),
			header: oneOf(obj.header),
		};

		obj = object;

		return h._(
			h.div(
				{ class: "card" },
				either(obj.header, h.div({ class: "card-header" }, obj.header)),
				either(obj.image !== null, () =>
					h.img({
						src: obj.image,
						class: "card-img-top",
						alt: "Card Image",
					})
				),
				either(
					obj.body,

					h.div(
						{ class: "card-body" },
						either(
							obj.title,
							h.h5(
								{ class: "card-title fw-400 text-black" },
								obj.title
							)
						),

						either(
							obj.subtitle,
							h.h6(
								{ class: "card-subtitle mb-2 text-muted" },
								obj.subtitle
							)
						),

						h.div({ class: "card-text" }, obj.body),

						either(obj.links, () => {
							let l = Array.isArray(obj.links)
								? obj.links
								: [obj.links];
							let links = [];

							for (let link of l) {
								links.push(
									h.a(
										{
											href: "#",
											class: "card-link",
										},
										link
									)
								);
							}

							return links;
						})
					),
					[
						either(
							obj.title,
							h.h5(
								{ class: "card-title fw-400 text-black" },
								obj.title
							)
						),

						either(
							obj.subtitle,
							h.h6(
								{ class: "card-subtitle mb-2 text-muted" },
								obj.subtitle
							)
						),

						...either(
							obj.links,
							() => {
								let l = Array.isArray(obj.links)
									? obj.links
									: [obj.links];
								let links = [];

								for (let link of l) {
									links.push(
										h.a(
											{
												href: "#",
												class: "card-link",
											},
											link
										)
									);
								}

								return links;
							},
							[]
						),
					]
				),
				either(obj.list && obj.list.length > 0, () => {
					let l = obj.list;

					let list = [];

					for (let li of l) {
						list.push(h.li({ class: "list-group-item" }, li));
					}

					return h.ul(
						{ class: "list-group list-group-flush pb-2" },
						list
					);
				}),

				...args
			)
		);
	}
}

ojs(Card);
